export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.5 5a1 1 0 011 1v12a1 1 0 01-1 1h-19a1 1 0 01-1-1V6a1 1 0 011-1h19zm-18 12h1.435A2 2 0 003.5 15.565V17zM6.968 7A4 4 0 013.5 10.468v3.063A4 4 0 016.968 17h10.064a4 4 0 013.468-3.469v-3.063A4 4 0 0117.032 7H6.968zM20.5 15.565A2 2 0 0019.065 17H20.5v-1.435zM19.065 7A1.998 1.998 0 0020.5 8.434V7h-1.435zM3.5 8.434A1.998 1.998 0 004.935 7H3.5v1.434z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};